import React, { Component } from 'react'
const DownloadFile = React.createClass({
  render() {
    let url = this.getAjaxUrlByFileType(this.props.fileType);
    return (
      <a className="download-file" href={url}>
        <i className="icon-download-1"/>
        {this.props.children}
      </a>
    );
  },
  getAjaxUrlByFileType(fileType){
    const fileId = this.props.fileId;
    if (fileType === 'image') {
      return `/ajax/event/${window.event_id}/posts/photos/${fileId}/download/`;
    }

    return '';
  }
});

export default DownloadFile;



// WEBPACK FOOTER //
// ./assets/es6/view_invitation/posts/components/download-file.es6